import {
        FETCH_ALUNOS_TURMA,
        FETCH_RANKING_ALUNOS_TURMA,
        FETCH_ALUNOS_PONTUACAO,
        FETCH_PONTUACAO_ALUNOS,
       } from '../actions/usuarioAction';

const INITIAL_STATE = { 
                        allUsuariosTurma      : [],
                        allPontuacaoAluno     : [],
                        allAlunoPontuacao     : false,
                        allAlunosRankingTurma : [],
                      };

export default function(state = INITIAL_STATE,action){

    switch (action.type) {

        case FETCH_ALUNOS_TURMA:
          return { ...state, allUsuariosTurma:(action.payload.data?action.payload.data:[]) }

        case FETCH_ALUNOS_PONTUACAO:
          return { ...state, allPontuacaoAluno:action.payload.data }

        case FETCH_PONTUACAO_ALUNOS:
          return { ...state, allAlunoPontuacao:action.payload.data }

        case FETCH_RANKING_ALUNOS_TURMA:
          return { ...state, allAlunosRankingTurma:action.payload.data }
        
        default:
        return state;
    }

}


// WEBPACK FOOTER //
// ./src/reducers/reducer_usuario.js